export const WM_EXPORTER_CONTENT_TYPE = 'application/json';
export const WM_EXPORTER_COMPRESSION = 'gzip';
export const WM_EXPORTER_HOST_BASE =
  'https://otel-collector-stage.meli.com/frontend';

export const NR_EXPORTER_HOST_BASE = 'https://otlp.nr-data.net:4318';

export const WM_EXPORTER_TRACES_ENDPOINT = `${WM_EXPORTER_HOST_BASE}/v1/traces`;
export const WM_EXPORTER_SPANS_ENDPOINT = WM_EXPORTER_TRACES_ENDPOINT;
export const WM_EXPORTER_METRICS_ENDPOINT = `${WM_EXPORTER_HOST_BASE}/v1/metrics`;
export const WM_EXPORTER_LOGS_ENDPOINT = `${NR_EXPORTER_HOST_BASE}/v1/logs`;
export const WM_EXPORTER_REQUIRED_KEY = 'false';
